export enum ExportDownloadsEvent {
    EXPORT_DOWNLOAD_FAILED = 'application-documents-export.download-failed',
    EXPORT_DOWNLOAD_READY = 'application-documents-export.download-ready',
  }